export default __webpack_public_path__ + "static/media/pinballfx.bdaf34c8.mp3";